





























import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    componentDataType
} from "../types";
import {
    pageDataType
} from "../types";
import {
    HOST
} from "../global";
import VueCircle from 'vue2-circle-progress/src/index.vue';

@Component({
    name: "CountryList",
    components: {
        VueCircle
    }
})
export default class CountryList extends Vue {
    @Prop() public compData!: string | null;
    public HOST: string = HOST;
     showmap: boolean = false;
    data() {
        return {
            fill: {
                gradient: ["#E71C23"]
            },
        }
    }
    handleScroll(event: any) {
        let d: any = document;
        let scrollpos = window.scrollY;
        const elem = d.querySelector('.countrylist-container');
        const counterlist = (window.scrollY + window.innerHeight);
        const isHalfshown = counterlist > elem.offsetTop;
        const countbottom = elem.offsetTop + elem.height;
        const isNotscrolledPast = window.scrollY < countbottom;
        if (isHalfshown) {
            (this as any).showmap = true;
        }

    }
    created() {
        window.addEventListener('scroll', this.handleScroll);
    }
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    //    progress(event,progress,stepValue){
    //     console.log(stepValue);
    //   }
    //   progress_end(event){
    //     console.log("Circle progress end");
    //   }

    // checkpoint() {

    //     var waypoints = document.querySelectorAll('.countrylist-container');
    //     waypoints.forEach(waypoint => {

    //         //halfway through the element
    //         const addClassAt = (window.scrollY + window.innerHeight) - waypoint.clientHeight / 2;

    //         const isHalfShown = addClassAt > (waypoint as any).offsetTop;

    //         const elementBottom = (waypoint as any).offsetTop + waypoint.clientHeight;
    //         const isNotScrollPast = (window.scrollY + window.innerHeight) <= elementBottom;

    //         if (isHalfShown && isNotScrollPast) {
    //             waypoint.classList.remove('active');
    //             waypoint.classList.add('reactive');
    //              waypoint.classList.remove((waypoint as any).getAttribute('data-classToRemove'));
    //             waypoint.classList.add((waypoint as any).getAttribute('data-classToAdd'));
    //         }
    //     });
    // }
    // created() {
    //     window.addEventListener("scroll", this.checkpoint);
    // }
    // destroyed() {
    //     window.removeEventListener("scroll", this.checkpoint);

    // }
    // mounted() {

    //     this.checkpoint();

    // }
}
